// Posts a form to Brevo from the page itself, the way Brevo's own embed
// script does (sibforms.com/forms/end-form/build/main.js): FormData to the
// form's URL with ?isAjax=1, answered with JSON { success, ... }. FormData
// makes this a CORS simple request, so there is no preflight.
//
// Generic on purpose: the /early-access form (ocl_online#170) and the on-site
// newsletter form (ocl_online#208) both post through it.
//
// Never throws. Resolves { ok: true } or { ok: false, reason }: 'rejected'
// (Brevo said no: a bad captcha, an invalid email), 'http' (a non-2xx or
// non-JSON reply), 'network' or 'timeout'.
export const submitBrevoForm = async (url, fields, { timeoutMs = 15000 } = {}) => {
  const body = new FormData();
  Object.entries(fields).forEach(([name, value]) => body.append(name, value));

  const controller = new AbortController();
  const timer = setTimeout(() => controller.abort(), timeoutMs);
  // One try/finally around both awaits, so the timer keeps running while the
  // body is read: abort() also rejects a body read in progress, and that
  // AbortError has to reach the caller as 'timeout', the same as an abort
  // during fetch() itself — otherwise a stalled body spins the button
  // forever with no failure message and no mailto fallback.
  try {
    let response;
    try {
      response = await fetch(`${url}?isAjax=1`, { method: 'POST', body, signal: controller.signal });
    } catch (error) {
      return { ok: false, reason: error && error.name === 'AbortError' ? 'timeout' : 'network' };
    }

    if (!response.ok)
      return { ok: false, reason: 'http' };
    let data;
    try {
      data = await response.json();
    } catch (error) {
      return { ok: false, reason: error && error.name === 'AbortError' ? 'timeout' : 'http' };
    }
    return data && data.success === true ? { ok: true } : { ok: false, reason: 'rejected' };
  } finally {
    clearTimeout(timer);
  }
};
